// @owlcat/app-shell/analytics-events — the fleet's ONE product-analytics event taxonomy.
//
// Every owlcat app captures the SAME named events with the SAME property shapes into ONE
// PostHog project (EU); `app_id` (super-property) and `$host` split them per app. A funnel
// like "landing → signed_in → <first core action> → checkout_completed" therefore works
// across apps without per-app dashboards, and a new app only picks the events it emits.
//
// Rules:
//   • snake_case names, past tense = a completed fact, `_started`/`_opened` = an intent.
//   • properties are small, non-PII facts (ids of OUR objects, enums, counts) — never free
//     text, names, emails, prompts. Money as minor units + currency, never card data.
//   • `useTrack()` is typed: a typo in the name or a wrong property is a compile error.
//   • capture is consent-gated + prod-only by the provider (analytics.tsx) — emit freely.
//
// Sections: fleet (every app) · billing (accounts + embedded widgets) · portal · games ·
// habits · film · shop. Add events here first, then emit them.
/** Names, for tests / tooling (dashboards, funnels). Keep in sync with FleetEvents. */
export const FLEET_EVENT_NAMES = [
    'signed_in', 'signed_up', 'signed_out', 'support_opened', 'support_sent',
    'checkout_started', 'checkout_completed', 'checkout_abandoned', 'subscription_changed', 'subscription_canceled', 'allowance_exhausted',
    'landing_demo_played', 'create_started',
    'story_created', 'story_text_generated', 'story_audio_generated', 'character_created', 'illustration_generated', 'book_exported_pdf',
    'video_exported', 'story_published', 'print_order_started', 'print_order_completed', 'voice_clone_created',
    'maze_generated', 'maze_completed', 'maze_shared',
    'habit_created', 'checkin_recorded', 'challenge_joined', 'challenge_completed', 'pet_hatched', 'pet_talk_started', 'pet_talk_ended', 'reminder_enabled',
    'film_created', 'film_gate_approved', 'film_produce_started', 'film_produce_completed', 'film_exported',
    'product_viewed', 'cart_added', 'order_started', 'order_completed',
];
